import React, { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";


import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import parse from "html-react-parser";
import PubSub from "pubsub-js";
import solisPowerApi from "../../api/solisPowerApi";
import { ROUTES } from "../../constants/webRouting";
import * as constants from "../../constants/CONSTANT";
import Permissionhelper from "../common/Permissionhelper";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  formatDate,
  formatDateTime,
  getFormattedTimestamp,
  getFormattedTimestampOfDate,
} from "../../utils/helper";
import Confirm from "../Confirm";
import { formatDateForCreatedDate } from "../../utils/helper";
import jwt_decode from "jwt-decode";
import RelatedListFiles from "../file/RelatedListFiles";
import FilesCreate from "../file/FilesCreate";
const HandoverView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [handover, SetHandover] = useState(location.state ? location.state : {});
  const [taskTargetDate, setTaskTargetDate] = useState();
  const [modalShow, setModalShow] = useState(false);
  console.log("View handover", handover);
  const [userInfo, setUserInfo] = useState({});
  const [showDetails, setShowDetails] = useState(true);
  const [editDisable, setDisableEdit] = useState(true);
  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [refreshFileList, setRefreshFileList] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);

  useEffect(() => {
    let userInfoJWT = jwt_decode(localStorage.getItem("token"));
    setUserInfo(userInfoJWT);
    fetchOffer();
    userInfoJWT.id === handover.owner_id && setDisableEdit(false);
  }, []);

  const fetchOffer = () => {
    if (
      !handover.id &&
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      handover.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await solisPowerApi.fetchHandoverRecordById(handover.id);
      // let order = await solisPowerApi.fetchOrderAmcById(handover.orderid);
      // const fetchPayment = await solisPowerApi.fetchOrderWisePayments(handover.id); //Using to Fetch Payments Record Wise By id

      // if (order) {
      //   SetHandover(order);
      // } else {
      //   setOrderAmc({});
      // }
      if (result) {
        SetHandover(result);
      } else {
        SetHandover({});
      }
      // if (fetchPayment) {
      //   setPayments(fetchPayment);
      // } else {
      //   setPayments({});
      // }
    }
    init();
  };
  const deleteHandover = async () => {
    console.log("handover.id", handover.id);
    const result = await solisPowerApi.deleteHandoverRecordById(handover.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
    navigate(ROUTES.HANDOVER.LIST);
  };

  const edit = () => {
    navigate(`${ROUTES.HANDOVER.LIST}/${handover.id}/e`, { state: handover });
  };

  // Related List Code Added By Farhan Khan Khan on 21-March-2025 

  const handleRelatedListTab = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    fetchOffer();
  };

  //End Here

  return (
    <Container className="pb-5">
      {handover && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteHandover={deleteHandover}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="handover"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HANDOVER.LIST)}>
                  Handover
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={8}>
                    <h6 className="m-0 ">Handover</h6>
                    <h4 className="m-0 ">{handover.offer_name_label || ""}</h4>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end gap-3">
                    {/* {Permissionhelper.checkPermission(
                    constants.SUPER_ADMIN
                  ) && ( */}
                    <Button
                      size="sm"
                      className="btn-edit"
                      onClick={() => edit(true)}
                    >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    {/* )} */}

                    {Permissionhelper.checkPermission(
                      constants.SUPER_ADMIN
                    ) && (
                        <Button
                          size="sm"
                          className="btn-delete"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button>
                      )}
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader>
                  {/* <Col lg={12} className="mt-4" style={{ color: "#fff" }}>
                  <Tabs
                    defaultActiveKey="details"
                    id="uncontrolled-tab-example"
                    onSelect={(key) => handleTab(key)}
                    style={{ marginBottom: "12px" }}
                  >
                    <Tab eventKey="details" title="Details"></Tab>
                    <Tab
                      eventKey="notesMessages"
                      title="Notes & Messages"
                    ></Tab>
                  </Tabs>
                </Col> */}
                </CardHeader>

                <CardBody>
                  <Container>
                    {(
                      <Row>
                        <Col lg={6}>
                          <label>Handover Date</label>
                          <span>{handover?.handover_date ? formatDate(handover.handover_date) : ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Offer</label>
                          <span>{handover?.offer_name_label || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Assigned User</label>
                          <span>
                            {/* Image Url for Production  */}
                            {/* <img src={`https://spark.indicrm.io/images/${userInfo.tenantcode}/users/${handover.ownerid}.thumbnail/${Math.random()}`} className="rounded-circle " style={{height: "20px", width: "20px", objectFit: "cover"}}/>   */}
                            {/* Image Url for Local  */}
                            <img
                              src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                              className="rounded-circle"
                              style={{
                                height: "30px",
                                width: "30px",
                                objectFit: "cover",
                              }}
                              alt=""
                            />
                            <img
                              src={localStorage.getItem("myimage")}
                              className="rounded-circle"
                              style={{ height: "30px" }}
                              alt=""
                            />

                            <Badge
                              bg="warning"
                              className="mx-2"
                              style={{ display: "inline", color: "#000" }}
                            >
                              {handover?.owner_name || ""}
                            </Badge>
                          </span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Assign Staff</label>
                          <span>{handover?.owner_name || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Email</label>
                          <span>{handover?.email || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Company Name</label>
                          <span>{handover?.company_name || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>HO Year</label>
                          <span>{handover?.ho_year || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>City</label>
                          <span>{handover?.city || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Pincode</label>
                          <span>{handover?.pincode || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Site Type</label>
                          <span>{handover?.site_type || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Contact Person Name</label>
                          <span>{handover?.contact_person_name || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Is Geared</label>
                          <span>{handover?.is_geared || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>File Number</label>
                          <span>{handover?.file_no || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Site Address</label>
                          <span>{handover?.site_address || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Product Capacity</label>
                          <span>{handover?.product_capacity || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Total Stops</label>
                          <span>{handover?.total_stops || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Auto Manual</label>
                          <span>{handover?.auto_manual || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Cabin Metal</label>
                          <span>{handover?.cabin_metal || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Elevator Type</label>
                          <span>{handover?.elevator_type || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Warranty Upto</label>
                          <span>{handover?.warranty_upto || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Customer Name Second</label>
                          <span>{handover?.customer_name_second || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Lost By</label>
                          <span>{handover?.lost_by || ""}</span>
                        </Col>
                      </Row>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="d-flex justify-content-between">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleRelatedListTab(key)}
              >
                <Tab eventKey="files" title="Files"></Tab>
              </Tabs>

              {relatedListFiles && (
                <Button
                  size="sm"
                  className="btn-custom float-right"
                  onClick={() => setModalShowFile(true)}
                >
                  New File
                </Button>
              )}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={handover}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}
            </Card.Header>
            <Card.Body>
              {relatedListFiles && (
                <RelatedListFiles
                  refreshFileList={refreshFileList}
                  // onFileUpdate={updateCounter}
                  parent={handover}
                  submitFiles={submitFiles}
                />
              )}

            </Card.Body>
          </Card>

        </>
      )}
    </Container>
  );
};
export default HandoverView;
